var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.6914 0 0 2.6914 0 6C0 9.3086 2.6914 12 6 12C9.3086 12 12 9.3086 12 6C12 2.6914 9.3086 0 6 0ZM5.74999 10C5.33641 10 4.99999 9.66359 4.99999 9.25001C4.99999 8.83643 5.33641 8.50001 5.74999 8.50001C6.16357 8.50001 6.49999 8.83643 6.49999 9.25001C6.49999 9.66359 6.16357 10 5.74999 10ZM6.49999 6.9502V7.75001C6.49999 7.8882 6.38817 8.00002 6.24998 8.00002H5.25C5.11181 8.00002 4.99999 7.8882 4.99999 7.75001V6.50002C4.99999 5.94874 5.44873 5.50001 6 5.50001C6.55127 5.50001 7.00001 5.05127 7.00001 4.5C7.00001 3.94873 6.55127 3.49999 6 3.49999C5.44873 3.49999 4.99999 3.94873 4.99999 4.5V4.75001C4.99999 4.8882 4.88817 5.00002 4.74998 5.00002H3.75C3.61181 5.00002 3.49999 4.8882 3.49999 4.75001V4.5C3.49999 3.12157 4.62157 1.99999 6 1.99999C7.37843 1.99999 8.50001 3.12159 8.50001 4.5C8.50001 5.69972 7.65478 6.71632 6.49999 6.9502Z",
    fill: "#5F788A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHQuestion);
export default __webpack_public_path__ + "static/media/HQuestion.615a5725.svg";
export { ForwardRef as ReactComponent };